<template lang="html">
  <v-dialog
     v-model="localValue"
    :fullscreen="isFullscreenMode"
    :persistent="!dismissable || isFullscreenMode"
    :transition="isFullscreenMode ? 'dialog-bottom-transition' : undefined"
    :hide-overlay="isFullscreenMode"
    :max-width="isFullscreenMode ? undefined: dialogMaxWidth"
    :scrollable="isFullscreenMode"
  >
    <template #activator="{ attrs, on }">
      <slot name="activator" v-bind="{ attrs, on }" />
    </template>

    <v-card style="overflow-y: unset">
      <template v-if="title || hasTitleSlot || dismissable">
        <v-card-title class="text-h6 primary--text d-flex flex-nowrap" style="gap: 20px;">
          <div class="flex-grow-1">
            <template v-if="title">
                {{ capitalize(title) }}
            </template>
            <template v-else>
              <slot name="title" />
            </template>
          </div>
          <div v-if="dismissable" class="d-flex justify-center align-self-start">
            <v-btn
              icon
              large
              @click="closeDialog"
            >
              <v-icon dark>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
      </template>
      
      <template v-if="subtitle || hasSubtitleSlot">
        <v-card-subtitle class="pb-1 text-caption ma-0">
          <template v-if="subtitle">
            {{ capitalize(subtitle) }}
          </template>
          <template v-else>
            <slot name="subtitle" />
          </template>
        </v-card-subtitle>
      </template>
    
      <v-card-text
        class="pl-3 pr-5 px-sm-6 pt-4 listwrapper"
        :class="{ 'searchfield__listwrapper': !isFullscreenMode }"
      >
        <template v-if="content">
          {{ capitalize(content) }}
        </template>
        <template v-else>
          <slot name="content" @close:dialog="closeDialog"/>
        </template>
      </v-card-text>

      <v-divider />

      <template v-if="hasAction">
        <v-card-actions class="justify-end ">
          <template v-if="hasActionSlot">
            <slot name="actions" />
          </template>
          <template v-else>
            <div class="mt-n2 full-width-global">
              <BaseDialogActions
                v-bind="$attrs"
                v-on="$listeners"
                :noCancel="!hasCancel"
                @cancel="closeDialog"
                @continue="continueAction"
              />
            </div>
          </template>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { capitalize, min } from 'lodash';
import localValue from '@/mixins/localValue';

export default {
  mixins: [localValue],
  props: {
    title: {
      type: String,
      default: undefined,
    },
    subtitle: {
      type: String,
      default: undefined,
    },
    content: {
      type: String,
      default: undefined,      
    },
    hasAction: {
      type: Boolean,
      default: true,
    },
    hasCancel: {
      type: Boolean,
      default: false,
    },
    dismissable: {
      type: Boolean,
      default: true,
    },
    minWidth: {
      type: [Number, String],
      default: 600,
    },
    fullscreen: {
      type: Boolean,
      default: false, 
    },
    disableCloseAfterContinue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasActionSlot() {
      return !!this.$slots['actions'] && !!this.$slots['actions'][0];
    },
    hasSubtitleSlot() {
      return !!this.$slots['subtitle'] && !!this.$slots['subtitle'][0];
    },
    hasTitleSlot() {
      return !!this.$slots['title'] && !!this.$slots['title'][0];
    },
    dialogMaxWidth() {
      return min([parseInt(this.minWidth), this.$vuetify.breakpoint.width]);
    },
    isFullscreenMode() {
      return this.fullscreen || this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    capitalize,
    continueAction() {
      if (this.disableCloseAfterContinue) return;
      this.closeDialog();
    },
    closeDialog() {
      this.localValue = false;
      this.$emit('click:close', true);
    }
  },
};
</script>

<style lang="css" scoped>
.searchfield__listwrapper {
  padding-top: 16px;
  max-height: 450px;
}

.listwrapper {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  overflow-y: auto;
}
</style>